// ajax模块
export default {
  'ajax.timeout': 'آسف، حدث خطأ ما، يرجى إعادة المحاولة لاحقا.',
  'ajax.system': 'آسف، حدث خطأ ما، يرجى إعادة المحاولة لاحقا.',
  'ajax.network': 'لا يوجد اتصال بالانترنت، يرجى إعادة المحاولة لاحقا.'
};
